import { connect } from 'react-redux'
import React from 'react'
import GuestSearch from 'components/GuestSearch/GuestSearch.jsx'
import actions from 'actions'

const {
    searchWebinars,
    saveSearchedWebinars
} = actions

class GuestSearchPage extends React.Component {
    constructor(props) {
      super(props)
    }

    searchWebinars(q) {
        try {
            // if(q.toLowerCase() === 'igpnea' || q.toLowerCase() === 'ipna') q = 'Irish General Practice Nurses Educational Assoc.'
            this.props.searchWebinars(q)
        } catch(err) {
            console.log(err)
        }
    }

    componentDidMount() {
        this.searchWebinars(this.props.location.query.q)
    }

    componentWillUnmount() {
        this.props.cleanWebinars()
    }
    
    componentWillReceiveProps = nextProps => {
        if (nextProps.location.query.q !== this.props.location.query.q) {
            this.searchWebinars(nextProps.location.query.q)
        }
    }


    render() {
        const {
            searchList,
            isSearching,
            cleanWebinars,
            location
        } = this.props

        return (
            <main className="site--width">
                <div className="section_webinars">
                    <h2 className="main_title">Search for {location.query.q}</h2>
                </div>
                <GuestSearch
                    webinars={searchList}
                />
            </main>
        )
    }
}

const mapStateToProps = state => ({
    searchList: state.webinars.searchList,
    isSearching: state.webinars.isSearching
})

const mapDispatchToProps = dispatch => ({
    searchWebinars: searchString => dispatch(searchWebinars(searchString)),
    cleanWebinars: () => dispatch(saveSearchedWebinars([]))
})

export default connect(mapStateToProps, mapDispatchToProps)(GuestSearchPage)


// WEBPACK FOOTER //
// ./src/containers/GuestSearchPage/GuestSearchPage.js